import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { format, parseISO } from "date-fns";
import BlockUi from "react-block-ui";
import { calculationsTypes } from "../../../constants/calculationsTypes";
import { Field } from "./clienteUi";

const formatUsage = value =>
  value !== null ? format(parseISO(value), "dd/MM/yyyy HH:mm") : "";

const USAGE_SECTIONS = [
  ["jurisprudences", "Jurisprudências"],
  ["opportunities", "Oportunidades"],
  ["queries", "Consultas Jusfinder"],
  ["signatures", "Assinador de documentos"],
  ["schedule", "Agenda"]
];

export default function Utilizacao(props) {
  const [loading, setLoading] = useState(true);
  const [features, setFeatures] = useState({});

  // o retorno não é usado no front, mas o POST tem efeito no servidor
  // (pode criar/renovar registro de assinatura) — não remover sem confirmar
  // o handler no jusfy-backend
  async function loadSubscription() {
    await axios.post(
      process.env.REACT_APP_API_URL + `/subscription/${props.cliente_id}`
    );
  }

  const getFeaturesUsage = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          `/subscription/features/usage/${props.cliente_id}`
      );
      if (response.data) {
        setFeatures(response.data);
      } else {
        toast.error("Ocorreu um erro ao carregar as features.");
      }
      setLoading(false);
    } catch (err) {
      toast.error("Ocorreu um erro ao carregar as features.");
      setLoading(false);
      return;
    }
  };

  useEffect(() => {
    getFeaturesUsage();
    loadSubscription();
  }, []);

  return (
    <BlockUi tag="div" blocking={loading}>
      <h2 className="jds-title-md mb-6">Cálculos</h2>
      <table className="table jds-table">
        <thead>
          <tr>
            <th>Funcionalidade</th>
            <th>Quantidade</th>
            <th>Última vez</th>
          </tr>
        </thead>
        <tbody>
          {features.calculations &&
            features.calculations.map(feature => (
              <tr key={feature.type}>
                <td>{calculationsTypes[feature.type]}</td>
                <td>{feature.count}</td>
                <td>
                  {format(parseISO(feature.last_usage), "dd/MM/yyyy HH:mm")}
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {USAGE_SECTIONS.map(([key, title]) => (
        <React.Fragment key={key}>
          <h2 className="jds-title-md cd-section-title">{title}</h2>
          {features[key] && (
            <div className="cd-fields-row">
              <Field label="Quantidade">{features[key].count}</Field>
              <Field label="Última utilização">
                {formatUsage(features[key].last_usage)}
              </Field>
            </div>
          )}
        </React.Fragment>
      ))}
    </BlockUi>
  );
}
